import { defineStore } from 'pinia';
import axios from 'axios';
import { ElMessage } from 'element-plus';

interface UserState {
  userInfo: {
    id: number;
    account: string;
    username: string;
    email: string;
    phone: string | null;
    avatarUrl: string | null;
    vip: number;
    vipExpiresAt: string | null;
    status: string;
    lastLoginAt: string;
    createdAt: string;
  } | null;
  loading: boolean;
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    userInfo: null,
    loading: false,
  }),

  actions: {
    async fetchUserInfo() {
      const token = localStorage.getItem('token');
      if (!token) return;

      this.loading = true;
      try {
        const response = await axios.get('https://aivitahelper.xyz:8081/api/user/me', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        this.userInfo = response.data.data;
      } catch (error: any) {
        const errorMessage = error?.response?.data?.message || error?.message || '获取用户信息失败';
        ElMessage.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },

    clearUserInfo() {
      this.userInfo = null;
    }
  },
});